export default function EmptyLine({height}) {
    return (
        <div style={{marginBottom: height || 4}} />
    )
}